import { fetchToken, fetchTokenV2 } from './auth'
import { fetchBusinessUnitList } from './businessUnits'
import invoices from './invoices'
import menu from './menu'
import orders from './orders'
import orderPayments from './orderPayments'
import paymentMethods from './paymentMethods'
import { fetchProfile } from './profile'
import { createConnection } from './webSocket'

export {
  brandUrl,
  imageUrl,
  qrCodeUrl
} from './resourceUrls'

export default {
  /**
   * For authentication.
   */
  auth: {
    fetchToken,
    fetchTokenV2
  },
  /**
   * For BusinessUnits management.
   */
  businessUnit: {
    fetchBusinessUnitList
  },
  /**
   * For Invoices management.
   */
  invoices,
  /**
   * For Menu management.
   */
  menu,
  /**
   * For Orders management.
   */
  orders,
  /**
   * For OrderPayment management.
   */
  orderPayments,
  /**
   * For PaymentMethods management.
   */
  paymentMethods,
  /**
   * For Profile management.
   */
  profile: {
    fetchProfile
  },
  /**
   * For connecting to WebSocket.
   */
  webSocket: {
    createConnection
  }
}
